import { Image } from '@cian/ui-kit';
import * as React from 'react';

import { FloorPlan } from '../FloorPlan';

interface IImageTile {
  fullUrl: string;
  onClick(): void;
  polygonPath?: string | null;
  isLayout?: boolean;
  isFloorPlan?: boolean;
}

export const ImageTile = ({ isFloorPlan, isLayout, fullUrl, onClick, polygonPath }: IImageTile) => {
  if (isFloorPlan) {
    return <FloorPlan fullUrl={fullUrl} polygonPath={polygonPath} onClick={onClick} />;
  }

  return (
    <Image
      objectFit={isLayout ? 'contain' : 'cover'}
      src={fullUrl}
      width="100%"
      height="100%"
      borderRadius="0"
      onClick={onClick}
    />
  );
};
